import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import * as Immutable from "immutable";
import { Button, Input } from "components/bootstrap";
import Spinner from "components/common/Spinner";
import useInputTypes from "components/inputs/useInputTypes";
const LoaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  .form-group {
    margin: 0 15px 0 0;
  }
`;
const StyledInputDropdown = styled(Input)`
  min-width: 400px;
`;
const PLACEHOLDER = "placeholder";
const InputOption = ({ input }) => {
  var _a;
  const { t } = useTranslation("inputs");
  const inputTypes = useInputTypes();
  const inputType = (_a = inputTypes == null ? void 0 : inputTypes[input.type]) != null ? _a : t("input_dropdown.unknown_type");
  return /* @__PURE__ */ React.createElement("option", { value: input.id }, t("input_dropdown.option", { title: input.title, type: inputType }));
};
const _formatInput = (input) => /* @__PURE__ */ React.createElement(InputOption, { key: input.id, input });
const _sortByTitle = (input1, input2) => input1.title.localeCompare(input2.title);
const StaticInput = ({ input }) => /* @__PURE__ */ React.createElement(StyledInputDropdown, { id: `${input.type}-select`, type: "select", disabled: true }, /* @__PURE__ */ React.createElement(InputOption, { input }));
const InputDropdown = ({
  disabled = false,
  inputs = Immutable.Map(),
  onLoadMessage = () => {
  },
  preselectedInputId = void 0,
  title
}) => {
  const { t } = useTranslation("inputs");
  const [selectedInput, setSelectedInput] = useState(preselectedInputId || PLACEHOLDER);
  const onSelectedInputChange = useCallback((event) => setSelectedInput(event.target.value), []);
  const _onLoadMessage = useCallback(() => onLoadMessage(selectedInput), [onLoadMessage, selectedInput]);
  const preselectedInput = useMemo(() => inputs == null ? void 0 : inputs.get(preselectedInputId), [inputs, preselectedInputId]);
  if (preselectedInput) {
    return /* @__PURE__ */ React.createElement(LoaderContainer, null, /* @__PURE__ */ React.createElement(StaticInput, { input: preselectedInput }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", disabled: selectedInput === PLACEHOLDER, onClick: _onLoadMessage }, title));
  }
  if (inputs) {
    const inputOptions = inputs.sort(_sortByTitle).map(_formatInput);
    return /* @__PURE__ */ React.createElement(LoaderContainer, null, /* @__PURE__ */ React.createElement(
      StyledInputDropdown,
      {
        id: "placeholder-select",
        type: "select",
        "aria-label": t("input_dropdown.label"),
        value: selectedInput,
        onChange: onSelectedInputChange,
        placeholder: PLACEHOLDER
      },
      /* @__PURE__ */ React.createElement("option", { value: PLACEHOLDER }, t("input_dropdown.select")),
      inputOptions.toArray()
    ), /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", disabled: disabled || selectedInput === PLACEHOLDER, onClick: _onLoadMessage }, title));
  }
  return /* @__PURE__ */ React.createElement(Spinner, null);
};
export default InputDropdown;
